import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';

import { EVatType, TEmVatListItem } from 'redux/reducers/emVat/types';
import { EIconButtons } from '../../../../../ui/EasTable/EasTableRow/EasTableValue/constants';

// id: number;
// emId: number;
// vatNumber: string;
// vatType: string;
// address: string;
// name: string;
// countryId: number;
// countryCode: string;

export const tableStructure: TTableStructure<keyof TEmVatListItem>[] = [
	{
		name: 'ID',
		selector: 'id' as keyof TEmVatListItem,
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'VAT Number',
		selector: 'vatNumber' as keyof TEmVatListItem,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'VAT Type',
		selector: 'vatType' as keyof TEmVatListItem,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		filter: [
			[EVatType.WAREHOUSE, 'Warehouse'],
			[EVatType.FIXED_ESTABLISHMENT, 'Fixed Establishment'],
		],
		// colors: [
		// 	['WAREHOUSE', 'success.main'],
		// 	['FIXED_ESTABLISHMENT', 'error.main'],
		// ],
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Name',
		selector: 'name' as keyof TEmVatListItem,

		show: true,
		sortable: false,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Country',
		selector: 'countryCode' as keyof TEmVatListItem,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.COUNTRY_CODE,
		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'Address',
		selector: 'address' as keyof TEmVatListItem,
		show: true,
		sortable: false,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Country',
		selector: 'countryId' as keyof TEmVatListItem,
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.COUNTRY_NUMBER,
		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'Actions',
		noName: true,
		selector: 'actions' as keyof TEmVatListItem,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.LEFT,
		buttons: [
			{
				name: 'Edit',
				icon: EIconButtons.EDIT,
			},
			{
				name: 'Delete',
				icon: EIconButtons.DELETE,
				color: 'error.main',
			},
		],
	},
];
